import React from 'react';
import { Box } from '@mui/material';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionSection } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionSection.tsx';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IStateAidGeneralInfoSectionProps {
  title: string;
  disabled: boolean;
}

export const StateAidGeneralInfoSection: React.FC<IStateAidGeneralInfoSectionProps> = ({
  title,
  disabled,
}) => (
  <FinancialConditionSection title={title}>
    <Box sx={documentGenerationFormStyles.fieldsGrid}>
      <FormDateInput name="documentDate" label="Дата довідки" disabled={disabled} />
      <FormInput
        name="companyFullName"
        label="Найменування / ПІБ позичальника"
        disabled
        fullWidth
      />
      <FormInput name="companyIdentifier" label="ЄДРПОУ / РНОКПП" disabled fullWidth />
    </Box>
  </FinancialConditionSection>
);
